import Dropdown, { useDropdownOutside, DropdownGroupProps } from '@anm/components/Dropdown';
import { VIDEO_TEMPLATE_ROUTE } from '@anm/constants/routes';
import capitalize from '@anm/helpers/string/capitalize';
import usePageParams from '@anm/hooks/usePageParams';
import { FC } from 'react';
import BetaLabel from '@anm/components/BetaLabel';
import { EMBED_INTERNAL_PARAM } from '@anm/constants/wave-editor';

import routes from '../../../routes';

import {
  CategoryText,
  ContentColumn,
  DropdownContentWrapper,
  DropdownItemContent,
  DropdownItemWrapper,
  ItemWrapper
} from './Wrapper';
import { getHoverColor } from './helpers';
import { CategoryDropdownProps, DropdownItemProps, DropdownLabel } from './types';

const { Link } = routes;

const DropdownItem: FC<DropdownItemProps> = ({ page, label, pageCategory, isOwnCategory, isHighlighted }) => {
  const { embed, isSemrush } = usePageParams();
  const route = VIDEO_TEMPLATE_ROUTE;
  const pageName = isOwnCategory ? page : `${pageCategory}-${page}`;

  const params = { pageName, ...(embed && { embed }), ...(isSemrush && { isSemrush })  };

  return (
    <Link {...{ route, params }}>
      <a>
        <DropdownItemContent {...{ isHighlighted }}>
          <DropdownItemWrapper>{capitalize(label, false)}</DropdownItemWrapper>
        </DropdownItemContent>
      </a>
    </Link>
  );
};

const CategoryDropdown: FC<CategoryDropdownProps & DropdownGroupProps> = ({
  label,
  list,
  delay,
  handleDropdownOpen,
  handleDropdownClose,
  color: pageColor,
  page: pageCategory
}) => {
  const [isOpened, handleOpenDropdown, handleCloseDropdown] = useDropdownOutside(
    handleDropdownOpen,
    handleDropdownClose
  );

  const { embed, isSemrush } = usePageParams();
  const params = { pageName: pageCategory, ...(embed && { embed }), ...(isSemrush && { isSemrush }) };
  const isInternalEmbed = embed === EMBED_INTERNAL_PARAM;

  const labelLowerCase = label.toLowerCase() as DropdownLabel;

  const color = isOpened ? getHoverColor(pageColor) : pageColor;

  return (
    <ItemWrapper
      label={labelLowerCase}
      {...{
        color,
        isOpened,
        isInternalEmbed
      }}
    >
      <Dropdown
        openDelay={delay}
        closeDelay={delay}
        onOpen={handleOpenDropdown}
        onClose={handleCloseDropdown}
        direction="to-bottom"
        renderContent={() => (
          <DropdownContentWrapper label={labelLowerCase}>
            {list.map(col => (
              <ContentColumn key={col[0].label}>
                {col.map(linkProps => (
                  <DropdownItem key={linkProps.page} {...{ ...linkProps, pageCategory }} />
                ))}
              </ContentColumn>
            ))}
          </DropdownContentWrapper>
        )}
      >
        <Link route={VIDEO_TEMPLATE_ROUTE} {...{ params }}>
          <a>
            <CategoryText isDropdown>
              {capitalize(label, false)}
              {label === 'image templates' && <BetaLabel styleVariant="new-yellow" positionVariant="top-right" />}
            </CategoryText>
          </a>
        </Link>
      </Dropdown>
    </ItemWrapper>
  );
};

export default CategoryDropdown;
